<script>
import OrderItem from '@/components/atoms/OrderItem'
import ImageWrapper from '@/components/atoms/ImageWrapper'
import Modal from '@/components/atoms/Modal'
import { mapGetters } from 'vuex'
import OrderDetails from '@/components/molecules/OrderDetails'
import Box from '@/components/atoms/Box.vue'
import NotificationAllowButton from '@/components/organism/restaurants/NotificationAllowButton.vue'
import ShareTracker from '@/components/organism/restaurants/ShareTracker.vue'
import sharedTracking from '@/modules/mixins/sharedTracking'

export default {
    name: 'SummaryOrderDetails',
    components: {
        ShareTracker,
        Box,
        OrderDetails,
        Modal,
        ImageWrapper,
        OrderItem,
        NotificationAllowButton,
    },
    mixins: [sharedTracking],
    data() {
        return {
            loading: false,
            show: false,
            hasScroll: false,
        }
    },
    computed: {
        ...mapGetters({
            lgDevice: 'lgDevice',
            smDevice: 'smDevice',
            order: 'summary/order',
            restaurant: 'summary/restaurant',
            restaurantManaged: 'summary/restaurantManaged',
            deliveryInitialized: 'summary/deliveryInitialized',
            deliveryCancelled: 'summary/deliveryCancelled',
            deliveryFinished: 'summary/deliveryFinished',
            orderApproved: 'summary/orderApproved',
            orderCancelled: 'summary/orderCancelled',
            orderProcessing: 'summary/orderProcessing',
            statusKey: 'summary/statusKey',
            courierStatusText: 'summary/courierStatusText',
        }),
        restaurant() {
            return this.order?.restaurant || {}
        },
        showDetails: {
            get() {
                return this.lgDevice || this.show
            },
            set(value) {
                if (!this.lgDevice) this.show = value
            },
        },

        orderRecipient() {
            if (this.order.deliveryName) return this.order.deliveryName.split(' ')[0]
            if (this.order.companyName) return this.order.companyName

            return null
        },
    },
    mounted() {
        this.checkScroll()
    },
    updated() {
        this.checkScroll()
    },
    methods: {
        checkScroll() {
            const el = this.$refs.scrollable
            if (!el) return

            this.hasScroll = el.scrollHeight > el.clientHeight
        },
        openDetails() {
            this.$refs.orderDetails.open()
        },
    },
}
</script>

<template lang="pug">
div.summary-order-details.d-flex
  box.card.shadow-1.border-radius-xs.d-flex.w-100(style="max-height:100%" v-if="order" v-model="showDetails" :read-only="lgDevice" header-class="card-header d-flex align-items-center justify-content-between bg-f7")
      template(v-slot:header)
          h3.my-0.text-26 {{$t('order.order_details')}}
      .card-body.d-flex.flex-column.h-100.px-lg-0
        div
          template(v-if="isSharedTrackingPage")
            .mb-5(v-if="orderRecipient") {{ $t('order.share_tracker.order_info') }} {{ orderRecipient }}
          template(v-else)
            share-tracker.mb-4
            notification-allow-button.mb-4
          .row.no-gutters.align-items-center
              .col-40
                  image-wrapper(:src="restaurant.card_image" width="30px" height="30px" fill rounded)
              .col.d-flex.flex-column
                  span.text-26 {{restaurant.name}}
                  span.text-73 {{$t('order.order')}}&nbsp;\#{{order.identifier}}
          hr(:class="{'mb-0' : hasScroll}")
        .summary-order-details-items(ref="scrollable")
            order-item(
                v-for="(item, index) in order.items"
                :key="`orderedItem-${index}`"
                :model="item"
                :locale="order.currency_locale"
                :currency="order.currency"
                :noBorder="index === 0"
                :show-price="false")
        div
          hr(:class="{'mt-0' : hasScroll}")
          .row.no-gutters(@click="openDetails" role="button")
              .col-40.d-flex.align-items-center
                  icon.text-primary(icon="receipt")
              .col.d-flex.flex-column
                  span.text-primary {{$t('order.view_receipt')}}

          order-details(
              ref="orderDetails"
              :order="order"
              :restaurant="restaurant"
              :order-processing="orderProcessing"
              :status-key="statusKey"
              :courier-status-text="courierStatusText"
              :delivery-finished="deliveryFinished"
          )
</template>
